if (!customElements.get('view-button')) {
  class ViewButton extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(
        new CustomEvent('view-as:update', {
          detail: { type: this.getAttribute('data-type') },
        }),
      );

      this.classList.add('is-active');
    }

    handleUpdate() {
      this.classList.remove('is-active');
    }

    connectedCallback() {
      if (!this.hasAttribute('data-type')) return;

      this.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('view-as:update', this.handleUpdateRef);
    }
  }

  customElements.define('view-button', ViewButton);
}
